const prefix = "BUDGET_SEARCH";
const createActionTypes = (resource) => ({
  LOAD: `${prefix}/${resource}/LOAD'`,
  LOADING: `${prefix}/${resource}/LOADING'`,
  LOADED: `${prefix}/${resource}/LOADED'`
});
const searchBudgetActionTypes = createActionTypes("SEARCH");
const loadExperimentBudgetActionTypes = createActionTypes("EXPERIMENT_BUDGET");
const updateCurrentMGActionType = `${prefix}/UPDATE_MANAGEMENTGROUP`;
const loadBudgetRequest = (request) => {
  return {
    type: searchBudgetActionTypes.LOAD,
    payload: request
  };
};
const loadingBudgetRequest = () => {
  return {
    type: searchBudgetActionTypes.LOADING,
    payload: {}
  };
};
const loadedBudgetRequest = (result) => {
  return {
    type: searchBudgetActionTypes.LOADED,
    payload: result
  };
};
const loadExperimentBudget = (experimentId) => {
  return {
    type: loadExperimentBudgetActionTypes.LOAD,
    payload: { experimentId }
  };
};
const loadingExperimentBudget = () => {
  return {
    type: loadExperimentBudgetActionTypes.LOADING,
    payload: {}
  };
};
const loadedExperimentBudget = (result) => {
  return {
    type: loadExperimentBudgetActionTypes.LOADED,
    payload: result
  };
};
const setCurrentManagementGroup = (managementGroup) => {
  return {
    type: updateCurrentMGActionType,
    payload: managementGroup
  };
};
export {
  createActionTypes,
  loadBudgetRequest,
  loadExperimentBudget,
  loadExperimentBudgetActionTypes,
  loadedBudgetRequest,
  loadedExperimentBudget,
  loadingBudgetRequest,
  loadingExperimentBudget,
  searchBudgetActionTypes,
  setCurrentManagementGroup,
  updateCurrentMGActionType
};
//# sourceMappingURL=SearchContainer.ducks.js.map
